import dynamic from 'next/dynamic'
import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react'
import router from 'next/router'

const AvailabilityInStore = dynamic(
	() => import('@bluheadless/ui/src/organisms/availability-in-store/availability-in-store'),
	{ ssr: false }
)

const AvailabilityInStoreContext = createContext()

const AvailabilityInStoreProvider = ({ children }) => {
	const [open, setOpen] = useState(false)
	const [productSku, setProductSku] = useState(null)

	const closeAvailabilityInStore = useCallback(() => {
		setOpen(false)
		setProductSku(null)
	}, [])

	useEffect(() => {
		router.events.on('routeChangeStart', closeAvailabilityInStore)
		return () => {
			router.events.off('routeChangeStart', closeAvailabilityInStore)
		}
	}, [closeAvailabilityInStore])

	const contextValue = useMemo(
		() => [
			{ availabilityInStoreOpened: open },
			{
				openAvailabilityInStore: (product) => {
					setProductSku(product)
					setOpen(true)
				},
				closeAvailabilityInStore,
			},
		],
		[closeAvailabilityInStore, open]
	)

	return (
		<AvailabilityInStoreContext.Provider value={contextValue}>
			{children}
			{productSku && <AvailabilityInStore onClose={closeAvailabilityInStore} open={open} productSku={productSku} />}
		</AvailabilityInStoreContext.Provider>
	)
}

export default AvailabilityInStoreProvider

export const useAvailabilityInStoreContext = () => {
	const availabilityInStoreContextValue = useContext(AvailabilityInStoreContext)

	if (!availabilityInStoreContextValue)
		console.warn(
			`AvailabilityInStore context value is missing. Verify that AvailabilityInStoreProvider is a parent of the current component.`
		)

	return availabilityInStoreContextValue
}
